import { API } from './api-core.service'

export const configurationService = {
  async getFormConfiguration(formModel, formAction) {
    return await API.request('GET', 'form-config', { formModel, formAction })
  },
  /**
   * Get form data to fill select or radio button
   * @param apiUrl (String) : url to reach
   * @param queryParams (Object) : parameters in the query (e.g. : "?firstname=Jean&lastname=Bon" will be { firstname: 'Jean', lastname: 'Bon' })
   */
  getFormData(apiUrl, queryParams) {
    return API.request('GET', apiUrl, queryParams, null)
  },
  /**
   * Get terms of service in requested language
   * @param {string} lang
   * @return {Promise<*|{errors}|{error}>}
   */
  async getCustomerTerms(lang) {
    return await API.request('GET', `api/terms-of-service/${lang}`, null, null, false)
  },
  /**
   * Get the translations from the API
   */
  async getTranslations() {
    return await API.request('GET', 'api/translations', null, null, false)
  },
  /**
   * Get static translation
   */
  getStaticTranslations() {
    let translations = {
      'fr-FR': {
        errors: {
          unauthorized: 'Non autorisé',
          forbidden: 'Interdit',
          tokenRevoked: 'Ce lien de création a déjà été utilisé ou est expiré. Veuillez contacter un conseiller ou un vendeur pour vous fournir un nouveau lien.',
          errorOccured: 'Une erreur est survenue. Veuillez contacter un conseiller ou un vendeur pour vous fournir un nouveau lien.'
        }
      },
      'de-DE': {
        errors: {
          tokenRevoked: 'Dieser Erstellungslink wurde bereits verwendet oder ist abgelaufen. Bitte wenden Sie sich an Ihren Verkaufsberater, um einen neuen Link zu erhalten oder Unterstützung bei der Erstellung Ihres Kundenkontos zu erhalten.'
        }
      },
      'en-CA': {
        errors: {
          tokenRevoked: 'This creation link has already been used or has expired. Please contact your sales advisor to obtain a new link or assistance in creating your customer account.'
        }
      },
      'en-GB': {
        errors: {
          tokenRevoked: 'This creation link has already been used or has expired. Please contact your sales advisor to obtain a new link or assistance in creating your customer account.'
        }
      },
      'en-US': {
        errors: {
          tokenRevoked: 'This creation link has already been used or has expired. Please contact your sales advisor to obtain a new link or assistance in creating your customer account.'
        }
      },
      'es-ES': {
        errors: {
          tokenRevoked: 'Este enlace de creación ya ha sido utilizado o ha caducado. Por favor, póngase en contacto con su asesor de ventas para obtener un nuevo enlace o asistencia en la creación de su cuenta de cliente.'
        }
      },
      'it-IT': {
        errors: {
          tokenRevoked: 'Questo link di creazione è già stato utilizzato o è scaduto. Si prega di contattare il proprio consulente di vendita per ottenere un nuovo link o assistenza nella creazione del proprio account cliente.'
        }
      },
      'ja-JP': {
        errors: {
          tokenRevoked: '此创建链接已被使用或已过期。请联系您的销售顾问获取新链接或帮助创建客户帐户'
        }
      },
      'ko-KR': {
        errors: {
          tokenRevoked: '이 생성 링크는 이미 사용되었거나 만료되었습니다. 새로운 링크를 받거나 고객 계정 생성에 대한 지원을 받으려면 판매 고문에게 문의하십시오.'
        }
      },
      'nl-BE': {
        errors: {
          tokenRevoked: 'Deze creatielink is al gebruikt of verlopen. Neem contact op met uw verkoopadviseur om een nieuwe link te verkrijgen of hulp bij het aanmaken van uw klantaccount.'
        }
      },
      'pt-PT': {
        errors: {
          tokenRevoked: 'Este link de criação já foi utilizado ou está expirado. Por favor, entre em contato com o seu consultor de vendas para obter um novo link ou assistência na criação da sua conta de cliente.'
        }
      },
      'zh-CN': {
        errors: {
          tokenRevoked: '此创建链接已被使用或已过期。请联系您的销售顾问获取新链接或帮助创建客户帐户'
        }
      },
      'zh-TW': {
        errors: {
          tokenRevoked: '此建立連結已被使用或已過期。請聯繫您的銷售顧問以獲取新的連結或協助建立您的客戶帳戶。'
        }
      }
    }
    
    return translations
  }
}
